{
  "instances": {
    "auditevents": {
      "audit_log_not_supported_spring_boot_1": "감사(Audit) 로그는 Spring Boot 1.x 버전의 애플리케이션은 지원하지 않습니다.",
      "event": "이벤트",

      "loading_audit_events": "감사(Audit) 이벤트 불러오는 중...",
      "no_audit_events_found": "감사(Audit) 이벤트를 찾을 수 없습니다.",
      "principal": "접근 주체",
      "remote_address": "원격 주소",
      "session_id": "Session Id",
      "timestamp": "Timestamp",
      "type": "Type",
      "label": "Audit Log"
    }
  }
}
